import { ListItem, Typography } from "@material-ui/core";
import React from "react";
import { HeaderMenuItemProps } from "./HeaderMenuItemProps";
import { headerMenuStyles } from "./HeaderMenuStyles";

export default function HeaderMenuItem(props: HeaderMenuItemProps) {
    const classes = headerMenuStyles();
    return (
        <ListItem
            button
            classes={{ selected: classes.selected }}
            onClick={props.onClickFunc}
            className={props.listItemStyles}
            selected={props.selectedState}
        >
            <Typography className={props.listItemTextStyles}>
                {props.text}
            </Typography>
        </ListItem>
    );
}
